
export const SET_ADMIN_USER = "SET_ADMIN_USER";
export const CLEAR_STATE = "CLEAR_COMMON_STATE";
export const SET_SELECTED_DETAILS = "SET_SELECTED_DETAILS";
export const SET_ADMIN_USER_CUSTOMER = "SET_ADMIN_USER_CUSTOMER"

